webpackJsonp([203433691802256],{

/***/ 307:
/***/ (function(module, exports) {

	module.exports = {"data":{"apteekkari":{"childImageSharp":{"sizes":{"aspectRatio":0.9660377358490566,"src":"/owla-ja-kadonnut-walkia/static/apteekkari_pose-a722563f2165026f75bf12a42456f6d2-dc516.png","srcSet":"/owla-ja-kadonnut-walkia/static/apteekkari_pose-a722563f2165026f75bf12a42456f6d2-2899d.png 128w,\n/owla-ja-kadonnut-walkia/static/apteekkari_pose-a722563f2165026f75bf12a42456f6d2-d42f9.png 256w,\n/owla-ja-kadonnut-walkia/static/apteekkari_pose-a722563f2165026f75bf12a42456f6d2-dc516.png 512w,\n/owla-ja-kadonnut-walkia/static/apteekkari_pose-a722563f2165026f75bf12a42456f6d2-f54c4.png 768w,\n/owla-ja-kadonnut-walkia/static/apteekkari_pose-a722563f2165026f75bf12a42456f6d2-db941.png 1024w","sizes":"(max-width: 512px) 100vw, 512px"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---liput-1eecad7c8a439f095de3.js